const map = {
	"./AD.svg": 68506,
	"./AE.svg": 71211,
	"./AF.svg": 32376,
	"./AG.svg": 67241,
	"./AI.svg": 35263,
	"./AL.svg": 84962,
	"./AM.svg": 47603,
	"./AO.svg": 39505,
	"./AR.svg": 32820,
	"./AS.svg": 58453,
	"./AT.svg": 48042,
	"./AU.svg": 65883,
	"./AW.svg": 92441,
	"./AZ.svg": 14620,
	"./BA.svg": 18442,
	"./BB.svg": 67737,
	"./BD.svg": 57767,
	"./BE.svg": 10902,
	"./BF.svg": 47541,
	"./BG.svg": 9556,
	"./BH.svg": 66595,
	"./BI.svg": 79634,
	"./BJ.svg": 68321,
	"./BL.svg": 87343,
	"./BM.svg": 50942,
	"./BN.svg": 13565,
	"./BO.svg": 85020,
	"./BQ.svg": 41242,
	"./BR.svg": 86057,
	"./BS.svg": 60696,
	"./BT.svg": 5623,
	"./BW.svg": 51172,
	"./BY.svg": 27074,
	"./BZ.svg": 67825,
	"./CA.svg": 38473,
	"./CD.svg": 3588,
	"./CF.svg": 69062,
	"./CG.svg": 58039,
	"./CH.svg": 22208,
	"./CI.svg": 20241,
	"./CK.svg": 66867,
	"./CL.svg": 60652,
	"./CM.svg": 8013,
	"./CN.svg": 8686,
	"./CO.svg": 39679,
	"./CR.svg": 70858,
	"./CU.svg": 99957,
	"./CV.svg": 63318,
	"./CW.svg": 26535,
	"./CY.svg": 20737,
	"./CZ.svg": 32050,
	"./DE.svg": 3448,
	"./DJ.svg": 30015,
	"./DK.svg": 99022,
	"./DM.svg": 12544,
	"./DO.svg": 69826,
	"./DZ.svg": 30095,
	"./EC.svg": 86553,
	"./EE.svg": 10343,
	"./EG.svg": 18389,
	"./EH.svg": 64274,
	"./ER.svg": 26488,
	"./ES.svg": 30729,
	"./ET.svg": 1286,
	"./FI.svg": 53702,
	"./FJ.svg": 76133,
	"./FK.svg": 24964,
	"./FM.svg": 15034,
	"./FO.svg": 78904,
	"./FR.svg": 50621,
	"./GA.svg": 40413,
	"./GB.svg": 28318,
	"./GD.svg": 73424,
	"./GE.svg": 88225,
	"./GF.svg": 6482,
	"./GG.svg": 39523,
	"./GH.svg": 82484,
	"./GI.svg": 43765,
	"./GL.svg": 32744,
	"./GM.svg": 98137,
	"./GN.svg": 72138,
	"./GP.svg": 4460,
	"./GQ.svg": 39917,
	"./GR.svg": 29198,
	"./GT.svg": 54112,
	"./GU.svg": 11025,
	"./GW.svg": 61203,
	"./GY.svg": 49093,
	"./HK.svg": 94626,
	"./HN.svg": 44927,
	"./HR.svg": 75547,
	"./HT.svg": 68117,
	"./HU.svg": 42484,
	"./ID.svg": 89298,
	"./IE.svg": 76259,
	"./IL.svg": 28106,
	"./IM.svg": 96923,
	"./IN.svg": 65032,
	"./IO.svg": 77401,
	"./IQ.svg": 96927,
	"./IR.svg": 17900,
	"./IS.svg": 65261,
	"./IT.svg": 36738,
	"./JE.svg": 18350,
	"./JM.svg": 78726,
	"./JO.svg": 13252,
	"./JP.svg": 28675,
	"./KE.svg": 17533,
	"./KG.svg": 7087,
	"./KH.svg": 40488,
	"./KI.svg": 5881,
	"./KM.svg": 37717,
	"./KN.svg": 65846,
	"./KP.svg": 82816,
	"./KR.svg": 98402,
	"./KW.svg": 48703,
	"./KY.svg": 50057,
	"./KZ.svg": 81946,
	"./LA.svg": 18396,
	"./LB.svg": 97423,
	"./LC.svg": 53694,
	"./LI.svg": 55444,
	"./LK.svg": 56182,
	"./LR.svg": 39039,
	"./LS.svg": 10606,
	"./LT.svg": 9105,
	"./LU.svg": 73152,
	"./LV.svg": 93907,
	"./LY.svg": 82212,
	"./MA.svg": 46323,
	"./MC.svg": 61521,
	"./MD.svg": 63022,
	"./ME.svg": 91455,
	"./MF.svg": 12428,
	"./MG.svg": 11373,
	"./MH.svg": 24698,
	"./MK.svg": 92809,
	"./ML.svg": 63366,
	"./MM.svg": 77751,
	"./MN.svg": 34628,
	"./MO.svg": 85797,
	"./MP.svg": 26354,
	"./MQ.svg": 40995,
	"./MR.svg": 83952,
	"./MS.svg": 19489,
	"./MT.svg": 6110,
	"./MU.svg": 49839,
	"./MV.svg": 70812,
	"./MW.svg": 60285,
	"./MX.svg": 73610,
	"./MY.svg": 33979,
	"./MZ.svg": 83240,
	"./NA.svg": 22534,
	"./NC.svg": 80740,
	"./NE.svg": 23834,
	"./NF.svg": 49417,
	"./NG.svg": 90264,
	"./NI.svg": 38862,
	"./NL.svg": 70867,
	"./NO.svg": 63776,
	"./NP.svg": 80007,
	"./NR.svg": 53429,
	"./NU.svg": 81802,
	"./NZ.svg": 50077,
	"./OM.svg": 97249,
	"./PA.svg": 96528,
	"./PE.svg": 4348,
	"./PF.svg": 6671,
	"./PG.svg": 70270,
	"./PH.svg": 87065,
	"./PK.svg": 37770,
	"./PL.svg": 66869,
	"./PM.svg": 28884,
	"./PR.svg": 33779,
	"./PS.svg": 46402,
	"./PT.svg": 74925,
	"./PW.svg": 75598,
	"./PY.svg": 80024,
	"./QA.svg": 86919,
	"./RE.svg": 30278,
	"./RO.svg": 79340,
	"./RS.svg": 50152,
	"./RU.svg": 75510,
	"./RW.svg": 74772,
	"./SA.svg": 74713,
	"./SB.svg": 48714,
	"./SC.svg": 90683,
	"./SD.svg": 59060,
	"./SE.svg": 20341,
	"./SG.svg": 46919,
	"./SH.svg": 50000,
	"./SI.svg": 64801,
	"./SK.svg": 16099,
	"./SL.svg": 88444,
	"./SM.svg": 16989,
	"./SN.svg": 4894,
	"./SO.svg": 67471,
	"./SR.svg": 90746,
	"./SS.svg": 96011,
	"./ST.svg": 47652,
	"./SV.svg": 89446,
	"./SX.svg": 30688,
	"./SY.svg": 87601,
	"./SZ.svg": 7202,
	"./TC.svg": 81366,
	"./TD.svg": 65049,
	"./TG.svg": 39050,
	"./TH.svg": 7325,
	"./TJ.svg": 80188,
	"./TK.svg": 95230,
	"./TL.svg": 55137,
	"./TM.svg": 40336,
	"./TN.svg": 6435,
	"./TO.svg": 73394,
	"./TR.svg": 42583,
	"./TT.svg": 6665,
	"./TV.svg": 86347,
	"./TW.svg": 81082,
	"./TZ.svg": 50399,
	"./UA.svg": 38763,
	"./UG.svg": 68421,
	"./UK.svg": 30353,
	"./US.svg": 17465,
	"./UY.svg": 58851,
	"./UZ.svg": 92752,
	"./VA.svg": 97982,
	"./VC.svg": 81532,
	"./VE.svg": 1874,
	"./VG.svg": 94672,
	"./VI.svg": 84118,
	"./VN.svg": 59353,
	"./VU.svg": 51874,
	"./WF.svg": 4290,
	"./WS.svg": 12975,
	"./XK.svg": 50514,
	"./YE.svg": 22899,
	"./YT.svg": 2930,
	"./ZA.svg": 92722,
	"./ZM.svg": 694,
	"./ZW.svg": 90700,
	"./ZZ.svg": 25993
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80702;